'use client';

import ConsultantForm from '@/components/ConsultantForm';
import { Language } from '@/lib/translations';
import { ITheme } from '@/types/theme';

interface ConsultantFormWrapperProps {
  language: Language;
  theme?: ITheme;
  backgroundColor?: 'primary' | 'secondary';
}

export default function ConsultantFormWrapper({
  language,
  theme,
  backgroundColor = 'primary',
}: ConsultantFormWrapperProps) {
  return (
    <ConsultantForm
      language={language}
      theme={theme}
      backgroundColor={backgroundColor}
    />
  );
}
